import CloseIcon from "@/assets/icons/xmark.svg";
import Clickable from "@/components/Clickable";
import { cx } from "@/utils";
import Tooltip from "@components/Tooltip";

import { ItemProps } from "./types";

import styles from "./TokenizedInput.module.css";

/**
 * This is the default items rendered for TokenizedInputs. If it needs overriding
 * the simplest way is to extend/duplicate this component and modify it. The
 * APIs should be fairly clear. try to maintain a relatively generic API.
 */
const DefaultItem: React.FunctionComponent<ItemProps> = ({
  value,
  onRemove,
  onEdit,
  className,
  errorMessage,
}) => {
  const content = (
    <Clickable
      onDoubleClick={onEdit}
      className={cx(
        styles.itemRoot,
        {
          [styles.itemError]: errorMessage,
        },
        className
      )}
    >
      {value}
      {/** To prevent a nesting error from React here I've chosen to make this button an anchor */}
      <a
        className={styles.itemRemove}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove();
        }}
      >
        <CloseIcon height="0.75rem" />
      </a>
    </Clickable>
  );
  if (!errorMessage) return content;
  return <Tooltip content={errorMessage}>{content}</Tooltip>;
};
export default DefaultItem;
